<template>
  <div id="main_content" class="vertical-flex min-height-100pct">
    <!-- Site Navbar -->
    <SiteNavBar :show-sub-accounts="true" :allow-switch="true" :allow-events="true" :is-main="true"/>
    <!-- /Site Navbar -->


    <!-- loader animation -->
    <div id="pageLoader" v-if="loading" class="fixed-top fade-in d-block">
      <!--<div class="ripple"><div></div><div></div></div>-->
      <!--<div class="spinner spinner-lg">
        <div class="rect1"></div>
        <div class="rect2"></div>
        <div class="rect3"></div>
        <div class="rect4"></div>
        <div class="rect5"></div>
      </div>-->
      <div class="rotator-container"><div class="rotator">
        <div><div><div><div></div></div></div><div><div><div></div></div></div></div>
        </div>
      </div>
    </div>
    <!-- / loader animation -->
    
    <router-view ref="topLevelRouter"></router-view>
    
    <SwitchAccounts v-if="privs.AO" ref="SwitchAccounts" />
    
    <Status ref="statusMessage" />
    
    <MessageDialog ref="messageDialog" />

    <NewAppVersion />

  </div>  
</template>


<script>
import {mapState} from 'vuex'
import SwitchAccounts from './ui/switch-accounts'
import MessageDialog from './ui/message-dialog'
import Status from './ui/status'
import Search from './search/search'
import SubscriberLookup from './lookup/subscriber-lookup'
import DateFormatting from '@/mixins/date-formatting'
import Email from '@/mixins/email'
import queryString from 'query-string'
import NewAppVersion from './ui/new-app-version'
import SiteNavBar from './ui/navbar'


export default {
  components: {SubscriberLookup,Status,MessageDialog,SwitchAccounts,Search,NewAppVersion,SiteNavBar},
  mixins: [DateFormatting,Email],
  data: function() { return {
    loadingTimer: null,
    accounts: []
  }},
  created: function() {
    this.$store.dispatch("fetchUiConfig");
    this.$store.commit("setDetailView",this.getLocalStorage('mobileResponsive','desktop'));
  },
  mounted: function() {
    let that = this;

    $( window ).resize(function() {
      if (that.viewType=='journey') {
        that.redrawJourneyView();
      } else if (that.viewType=='list' && that.resultsSearchType=='email') {
        that.resizePreviewPane();
      }
    });

    $(document).keyup(function(e) {
      if (e.keyCode === 27) that.processEscapeKey();   // esc
    });

    //TODO: dispatch this to the store.
    //this.paginator.pageSize = this.getLocalStorage('pageSize',100);

    setTimeout( ()=>{that.$store.commit("setLoading",false);}, 1000);
    
    if (location.search){
      let qs = queryString.parse(location.search);
      this.$store.commit("setQsParams",qs)
    }
    console.log("main mounted")

  },
  updated: function() {
  },
  computed: {
    ...mapState({
      uiConfig: (state)=>state.user.uiConfig,
      privs: (state)=>state.user.privs,
      emails: (state)=>state.search.emails,
      loading: (state)=>state.ui.loading,
      activeView: (state)=>state.ui.activeView,
      detailView: (state)=>state.ui.detailView,
      activeSubAccount: (state)=>state.ui.activeSubAccount,
      viewType: (state)=>state.ui.viewType,      
      selectedEmail: (state)=>state.search.selectedEmail,
      activeEmailSearch: (state)=>state.search.activeEmailSearch,
      emailsearchParams: (state)=>state.search.searchParams,
      filterEmail: (state)=>state.search.filterEmail,
      paginator: (state)=>state.search.paginator,
      resultsSearchType: (state)=>state.search.resultsSearchType,
      resultsKey: (state)=>state.search.resultsKey,
      resend: (state)=>state.search.resend,      
      showEmailEvents: (state)=>state.user.showEmailEvents,
      showDemoEvents: (state)=>search.showDemoEvents,
    }),
    subAccounts: function(){
      return this.uiConfig.sub_accounts;
    },
    activeSubAccountDisplayName: function() {
      return (this.activeSubAccount)? this.activeSubAccount.sub_account_display_name : 'All sources';
    },


  },
  methods: {
    setActiveView(name){
      this.$store.commit("setActiveView",name);      
    },
    showLoading(duration) {
      let that = this;
      let loadTime = duration!=undefined ? duration : 1000;

      that.$store.commit( "setLoading",true);
      setTimeout(()=>{that.$store.commit( "setLoading",false);}, loadTime)
    },

    showResend(controlId){
      this.$store.commit("setResendChange",true);
      this.$nextTick(()=>{
        $(`#${controlId}`).focus();        
      })
    },
    processEscapeKey() {
      try {
        if (this.viewType=='journey') {
          this.$refs.topLevelRouter.$refs.journeyView.hidePopover();
        }
        if (this.activeView=='search') {
          this.$refs.topLevelRouter.$refs.searchBar.closeFilterPane();
        } else if (this.activeView=='detail') {
          this.$store.commit("setActiveView","search");
        }
      } catch (e) {
        // trapping for error when refs don't exist
      }
    },
    toggleEventState() {
      this.$store.commit("setDemoEventDisplay",!this.showDemoEvents);
    },
    redrawJourneyView(){
      try {
        this.$refs.topLevelRouter.$refs.journeyView.redrawJourneyView();
      } catch(e) {

      }
    },
    resizePreviewPane() {
      try {
        this.$refs.topLevelRouter.$refs.listView.resizePreviewPane();  
      } catch(e) {
        // don't need to throw error when listView component is not displayed
      }
    },
    showDetail() {
      this.$store.commit("setResendChange",false);
      this.setActiveView('detail');
    },
    getLocalStorage(key,defaultVal = null) {

      let ret = localStorage.getItem(key);

      if (ret!=undefined) {
        return ret;
      } else if (defaultVal!=undefined) {
        return defaultVal;
      }

    },

    switchAccounts() {
      console.log(this.$refs);
      this.$refs.SwitchAccounts.showAccounts();
    },

    sortRecords(colElement){

    },

    clearSearchResults() {

    },

  },
  watch: {
    'detailView': function() {
      localStorage.setItem("mobileResponsive", this.detailView);
    },

    'activeView': function(newVal, oldVal) {
      if (newVal=='lookup') {
        this.showLoading(750);
        //this.$refs.topLevelRouter.$refs.subscriberLookup.doLookup();  
      } else if (newVal=='search' && oldVal=='lookup') {
        if (this.filterEmail && this.filterEmail!=this.resultsKey) { // run email search if value changed``
          this.$refs.topLevelRouter.$refs.searchBar.doSearch();
        } else if (!this.filterEmail) {
          this.$store.dispatch("clearResults");
        } else if (this.filterEmail==this.resultsKey) {
          this.$refs.topLevelRouter.$refs.listView.resizePreviewPane();
        }
      }

    },

  }, //end watch
}

</script>